import { ProductRegistrationQuery } from 'models/productRegistration';

export function createProductRegistrationBody(data: ProductRegistrationQuery) {
  const { product, customer, soldDate } = data;
  return {
    attributes: {
      product: {
        iprId: product.iprId
      },
      customer: {
        type: customer.attributes.type,
        country: customer.attributes.country
      },
      soldDate: soldDate ?? Date.now(),
      brand: product.brand
    }
  };
}
